import PropTypes from "prop-types";
import { useState, useEffect, Fragment, isValidElement } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { FaTimes } from "../Icon/fa/FaTimes";


/* components */
export const ModalHeader = ({ children, ...props }) => {
  return <div {...props}>{children}</div>;
};

export const ModalBody = ({ children, ...props }) => {
  return <div {...props}>{children}</div>;
};

export const ModalFooter = ({ children, ...props }) => {
  return <div {...props}>{children}</div>;
};

/**
 *
 * @param {{
 * size: "sm" | "md" | "lg" | "xl"
 * }} props Props for the component
 *
 */
const ModalDialog = ({
  data,
  isOpen,
  closeButton,
  callback,
  cancelCallBack,
  children,
  size,
  ...props
}) => {
  const CloseButton = closeButton;
  const [isShow, setIsShow] = useState(false);
  const [modalSize, setModalSize] = useState("");

  useEffect(() => {
    setIsShow(isOpen);
  }, [isOpen]);

  useEffect(() => {
    // switch (size) {
    //   case "xs":
    //     setModalSize("w-full lg:w-1/2");
    //     break;
    //   case "sm":
    //     setModalSize("w-full md:w-1/2 lg:w-2/3");
    //     break;
    //   case "md":
    //     setModalSize("w-full md:w-2/3 lg:w-3/4");
    //     break;
    //   case "lg":
    //     setModalSize("w-full md:w-4/5 lg:w-3/5");
    //     break;
    //   case "xl":
    //     setModalSize("w-full md:w-full lg:w-5/6");
    //     break;
    //   default:
    //     setModalSize("lg:w-full");
    //     break;
    // }
    switch (size) {
      case "xs":
        setModalSize("w-full lg:w-3/12");
        break;
      case "sm":
        setModalSize("w-full lg:w-4/12");
        break;
      case "md":
        setModalSize("w-full lg:w-6/12");
        break;
      case "lg":
        setModalSize("w-full lg:w-8/12");
        break;
      case "xl":
        setModalSize("w-full lg:w-10/12");
        break;
      default:
        setModalSize("lg:w-full");
        break;
    }
  }, [size]);

  const handleClose = () => {
    setIsShow(false);
    cancelCallBack && cancelCallBack();
  };

  return (
    <>
      <Transition appear show={isShow} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 overflow-y-auto"
          style={{ zIndex: 100 }}
          onClose={handleClose}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-slate-900 opacity-70" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div
                className={`relative inline-flex transform flex-col justify-center rounded-2xl border-2 bg-white text-left align-middle shadow-xl transition-all ${modalSize}`}
                style={props.style}
              >
                <div className="absolute top-4 right-4 z-10">
                  {isValidElement(<CloseButton />) && (
                    <CloseButton onClick={handleClose} />
                  )}
                </div>
                {children}
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

ModalDialog.propTypes = {
  closeButton: PropTypes.any,
};

ModalDialog.defaultProps = {
  closeButton: (props) => (
    <button
      type="button"
      className="inline-flex justify-center rounded-full border-none p-1 text-xl font-medium transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
      onClick={props.onClick}
    >
      <FaTimes size={21} />
    </button>
  ),
};

export default ModalDialog;

// export default Object.assign(ModalDialog, {
//   Header: Header,
//   Body: Body,
//   Footer: Footer,
// });
